/**
 * Created by Andrey Popov on 06.08.26
 */

cleverapps.override(cleverapps.EVENTS, {
    GAME_ANNOUNCE_AVAILABLE: "game_announce_available",
    GAME_ANNOUNCE_SHOWN: "game_announce_shown",
    GAME_ANNOUNCE_FIRSTLAUNCH: "game_announce_firstlaunch",
    GAME_ANNOUNCE_ARRIVE: "game_announce_arrive",
    GAME_ANNOUNCE_PAY: "game_announce_pay"
});
